// @flow
// TODO: Consider refactoring this file to reduce complexity.
import moment from 'moment';
import {
  WHITELIST_TURBO_BANNER_STAGING,
  WHITELIST_TURBO_CAMPAIGN_PRODUCTION
} from './whitelist-turbo-campaign';

export const WHITELIST_TURBO_STAGING = [
  'bc-dev-v2-iris10.myshopify.com',
  'bc-dev-erin.myshopify.com',
  'bc-dev-ellie-test.myshopify.com',
  'bc-dev-v2-clara02.myshopify.com',
  'bc-dev-v2-helen3.myshopify.com'
];

export const LIST_TENANT_NOT_SHOW_MODAL = [
  '9313ca-2.myshopify.com',
  'c9f955-3.myshopify.com',
  'castoreaus.myshopify.com',
  'chicoryhome.myshopify.com',
  'ecanta.myshopify.com',
  'keitoya.myshopify.com',
  'loomandloft2.myshopify.com',
  'nomax-norway.myshopify.com',
  'root-and-blow.myshopify.com',
  'yakirabella.myshopify.com'
];

export const WHITELIST_TURBO_PRODUCTION = [
  '00878d-5e.myshopify.com',
  '019d6b-3.myshopify.com',
  '035cf4-f8.myshopify.com',
  '0527f0.myshopify.com',
  '082007.myshopify.com',
  '0riginalfeet.myshopify.com',
  '12c7b7.myshopify.com',
  '0e9a24-2.myshopify.com',
  '13606c-3.myshopify.com',
  '110528-3.myshopify.com',
  '10b613-3.myshopify.com',
  '1395c7.myshopify.com',
  '178602.myshopify.com',
  '178242-3.myshopify.com',
  '1cc8fc-3.myshopify.com',
  '1b1951.myshopify.com',
  '0935f9.myshopify.com',
  '1c912d-2.myshopify.com',
  '1b32ec-d8.myshopify.com',
  '207650-5.myshopify.com',
  '22117b.myshopify.com',
  '21edfd-2.myshopify.com',
  '26557c-c6.myshopify.com',
  '256503.myshopify.com',
  '243c24.myshopify.com',
  '28e677.myshopify.com',
  '2ac1b1-2.myshopify.com',
  '2amstudioofficial.myshopify.com',
  '2e813f.myshopify.com',
  '2f4da2.myshopify.com',
  '291203-2.myshopify.com',
  '2nd-to-none-co.myshopify.com',
  '318e42-78.myshopify.com',
  '35286a-4.myshopify.com',
  '365fb2-2.myshopify.com',
  '322d0a.myshopify.com',
  '39a796.myshopify.com',
  '3bb54e.myshopify.com',
  '3aec80-2.myshopify.com',
  '34405b-4.myshopify.com',
  '37633b-2.myshopify.com',
  '374a6a-2.myshopify.com',
  '33d38e-3.myshopify.com',
  '3f351c-2.myshopify.com',
  '3d0f81-2.myshopify.com',
  '430fa6-3.myshopify.com',
  '3dverkstandk.myshopify.com',
  '3b0e99.myshopify.com',
  '4cb897-2.myshopify.com',
  '46d8a4-2.myshopify.com',
  '4ddba9-3.myshopify.com',
  '49db8b-3.myshopify.com',
  '4f1b22-3.myshopify.com',
  '50ab7c.myshopify.com',
  '520892-2.myshopify.com',
  '502fdb.myshopify.com',
  '54769c-2.myshopify.com',
  '568a79-5.myshopify.com',
  '575575-2.myshopify.com',
  '510ed7-3.myshopify.com',
  '5558ad.myshopify.com',
  '559490-3.myshopify.com',
  '58d456.myshopify.com',
  '5c6a3f.myshopify.com',
  '59e932-4.myshopify.com',
  '611ebf-2.myshopify.com',
  '5f2e5c-2.myshopify.com',
  '569af1-5.myshopify.com',
  '5c6e7b-2.myshopify.com',
  '64ad96.myshopify.com',
  '67acdb-3.myshopify.com',
  '686bea.myshopify.com',
  '683b14.myshopify.com',
  '6af8cd-2.myshopify.com',
  '66a0a0-2.myshopify.com',
  '6c5f63-3.myshopify.com',
  '6ec90d-e1.myshopify.com',
  '6c3482.myshopify.com',
  '6f3b99-3.myshopify.com',
  '730558-2.myshopify.com',
  '736bc9.myshopify.com',
  '753653-2.myshopify.com',
  '73871b.myshopify.com',
  '77d122-3.myshopify.com',
  '70f8a8.myshopify.com',
  '76b0b2.myshopify.com',
  '79510b-2.myshopify.com',
  '79643b-3.myshopify.com',
  '7a5637.myshopify.com',
  '6aa06b-2.myshopify.com',
  '7db659-3.myshopify.com',
  '777fd5-b7.myshopify.com',
  '7e7e84.myshopify.com',
  '77b32a-3.myshopify.com',
  '86f6a5.myshopify.com',
  '86fce4.myshopify.com',
  '85c303.myshopify.com',
  '889fb7-2.myshopify.com',
  '88cd40-3.myshopify.com',
  '8a5a6c-3.myshopify.com',
  '8dio-com.myshopify.com',
  '8dd734-5.myshopify.com',
  '8b922c.myshopify.com',
  '8d2bd1.myshopify.com',
  '8f8c03.myshopify.com',
  '901f3c.myshopify.com',
  '922290-2.myshopify.com',
  '925fd1-5.myshopify.com',
  '93f5af.myshopify.com',
  '97e80e-3.myshopify.com',
  '973e35-3.myshopify.com',
  '94e05e-2.myshopify.com',
  '9ba1c6.myshopify.com',
  '9c8c79.myshopify.com',
  '9e54de.myshopify.com',
  '9e145c-99.myshopify.com',
  '982bb1-2.myshopify.com',
  '9c04c0-2.myshopify.com',
  'a1aefd.myshopify.com',
  'a2e1e1-2.myshopify.com',
  'a1598b-2.myshopify.com',
  'a218a4-2.myshopify.com',
  'a4eb82-2.myshopify.com',
  'a8c46d-4.myshopify.com',
  '9ef9b1.myshopify.com',
  'a54b8f.myshopify.com',
  'a37ec4-3.myshopify.com',
  'a566e1-3.myshopify.com',
  'abf746-5.myshopify.com',
  'accio-box.myshopify.com',
  '90f24f-3.myshopify.com',
  'ackerbaum.myshopify.com',
  'ad759b.myshopify.com',
  'aadyaa-originals-pvt-ltd.myshopify.com',
  'adorevintagecanada.myshopify.com',
  'aed-team.myshopify.com',
  'aiage23.myshopify.com',
  'accessorizelondon.myshopify.com',
  'albercas-y-punto.myshopify.com',
  'alastin.myshopify.com',
  'alltrueist.myshopify.com',
  'airthreads.myshopify.com',
  'altitude-authentics.myshopify.com',
  'amavi-mm.myshopify.com',
  'amicciuk.myshopify.com',
  'alkemispaint.myshopify.com',
  'anchoredbylove.myshopify.com',
  'angel-brinks.myshopify.com',
  'animalpride-com.myshopify.com',
  'apreseveryday.myshopify.com',
  'arpar-shop.myshopify.com',
  'artblownstore.myshopify.com',
  'asia-minor-carpets.myshopify.com',
  'atelier-yuka-photo-wedding.myshopify.com',
  'australian-cookie-cutters.myshopify.com',
  'authenticstreetsigns.myshopify.com',
  'av-uruguay.myshopify.com',
  'ava-the-brand.myshopify.com',
  'b12454-2.myshopify.com',
  'b10631-3.myshopify.com',
  'away-that-day.myshopify.com',
  'b32973-4.myshopify.com',
  'b77d40-85.myshopify.com',
  'ba084c.myshopify.com',
  'babe-new.myshopify.com',
  'ba1b4d.myshopify.com',
  'babyhouse-australia.myshopify.com',
  'badpeaches.myshopify.com',
  'ballantynes-jewellers.myshopify.com',
  'bc-prod-v3-pm.myshopify.com',
  'bdc21b-2.myshopify.com',
  'beaver-snax.myshopify.com',
  'bebf3d-2.myshopify.com',
  'bee29e-2.myshopify.com',
  'bella-epoca-zapateria.myshopify.com',
  'bellino-gems.myshopify.com',
  'bento-gaming-ca.myshopify.com',
  'best-collection-boutique.myshopify.com',
  'bettababy.myshopify.com',
  'bestknifestore.myshopify.com',
  'bicisportchile.myshopify.com',
  'billini1.myshopify.com',
  'billsons-beechworth.myshopify.com',
  'blacfundsmatter.myshopify.com',
  'blackbear-boutique.myshopify.com',
  'blueridgeoutfitters.myshopify.com',
  'blongser.myshopify.com',
  'bmc-bikes-inc.myshopify.com',
  'boboandbooau.myshopify.com',
  'bonita-de-mas.myshopify.com',
  'blue-sky-scrubs.myshopify.com',
  'blissy-brand.myshopify.com',
  'boost-pfs-test-sarah02.myshopify.com',
  'bosch-pt-ro.myshopify.com',
  'boost-pfs-test-kaylee02.myshopify.com',
  'boost-sd-dev-test-paola.myshopify.com',
  'boost-pfs-test-v3-amy.myshopify.com',
  'boutique-bella-blue.myshopify.com',
  'box-of-books-prod.myshopify.com',
  'branch-and-vines.myshopify.com',
  'braingain2.myshopify.com',
  'boycott-1.myshopify.com',
  'brands-establishment.myshopify.com',
  'box-babe-gift-co.myshopify.com',
  'brand-ring.myshopify.com',
  'brandtokyo-jp.myshopify.com',
  'boost-pfs-test-v3-sunny.myshopify.com',
  'brandsmegastore.myshopify.com',
  'brew-culture-craft-brewing-supplies.myshopify.com',
  'bremner-tcg.myshopify.com',
  'brooklyn-bred-since-1930.myshopify.com',
  'broadway-limited-imports.myshopify.com',
  'bravobraboutique.myshopify.com',
  'bull-and-briar-leather-llc.myshopify.com',
  'bunker-hill-design-plllc.myshopify.com',
  'burdlife.myshopify.com',
  'c25671-2.myshopify.com',
  'c0e1b2.myshopify.com',
  'c2-paint.myshopify.com',
  'c625e7-3.myshopify.com',
  'c4b644-2.myshopify.com',
  'c86883-3.myshopify.com',
  'c705b6.myshopify.com',
  'c2bac0-3.myshopify.com',
  'c7f707.myshopify.com',
  'c90ad5-2.myshopify.com',
  'c8a643-3.myshopify.com',
  'cabinet-hardware-specialties.myshopify.com',
  'caffetteria-stazione.myshopify.com',
  'c9b83e-3.myshopify.com',
  'c7d614.myshopify.com',
  'cap-rouge.myshopify.com',
  'capusanyc.myshopify.com',
  'carstomised.myshopify.com',
  'carrdan-preservation-supply.myshopify.com',
  'cb11de-2.myshopify.com',
  'cce3f2-3.myshopify.com',
  'carner-bcn.myshopify.com',
  'chargit-store.myshopify.com',
  'chippindale-plant.myshopify.com',
  'ciano-farmer-denim-co.myshopify.com',
  'ciss-cola.myshopify.com',
  'clb-xxiii.myshopify.com',
  'cokerexpo.myshopify.com',
  'collegiatepulse.myshopify.com',
  'colorado-canyon-enthusiasts.myshopify.com',
  'colmoda-usa.myshopify.com',
  'commit-watch.myshopify.com',
  'contrast-living.myshopify.com',
  'compression-socks-fdm.myshopify.com',
  'contact-225.myshopify.com',
  'consequence-store.myshopify.com',
  'contact-675.myshopify.com',
  'comfort-company-inc.myshopify.com',
  'coughy.myshopify.com',
  'courtneyscandles1992.myshopify.com',
  'cover-corp.myshopify.com',
  'cramerco.myshopify.com',
  'craniologie-llc.myshopify.com',
  'creature-racing-parts.myshopify.com',
  'crossfor.myshopify.com',
  'cutting-tool-pickers-1.myshopify.com',
  'cwjewellers.myshopify.com',
  'd0a140.myshopify.com',
  'd-estetika.myshopify.com',
  'd72a77-4.myshopify.com',
  'd76af7-3.myshopify.com',
  'd5704e.myshopify.com',
  'd9daeb-04.myshopify.com',
  'd3bae9-2.myshopify.com',
  'daintydiamond.myshopify.com',
  'dasbootleg.myshopify.com',
  'dc6efa-5.myshopify.com',
  'dbf909.myshopify.com',
  'dd651e.myshopify.com',
  'dansonjewelers.myshopify.com',
  'demakers.myshopify.com',
  'deniliquin-jewellers.myshopify.com',
  'devine-lux-clothing-apparel.myshopify.com',
  'dfa66a-3.myshopify.com',
  'df11d1-3.myshopify.com',
  'digger-tactical-australia.myshopify.com',
  'dirbhos.myshopify.com',
  'direct-hemp-distributor.myshopify.com',
  'dispatchtalent-4709-2.myshopify.com',
  'djbox-ie-dj-shop.myshopify.com',
  'doghouse-distillery-new-build.myshopify.com',
  'domestic-spare-parts.myshopify.com',
  'doorsforsale.myshopify.com',
  'dripcityjewellers.myshopify.com',
  'dubai-jewellers-2226.myshopify.com',
  'dwell-home-market.myshopify.com',
  'e01316-3.myshopify.com',
  'e2054b.myshopify.com',
  'e3eb06-91.myshopify.com',
  'e2a613.myshopify.com',
  'e4aa55-2.myshopify.com',
  'e4c146-2.myshopify.com',
  'e48fbd-2.myshopify.com',
  'e4c47f-2.myshopify.com',
  'e654c3.myshopify.com',
  'e9b14d.myshopify.com',
  'ebiketechnology.myshopify.com',
  'echo-boutique-im.myshopify.com',
  'ecommerceworld1.myshopify.com',
  'ee7944-2.myshopify.com',
  'ef7b89.myshopify.com',
  'eddiebauer-jp.myshopify.com',
  'element-tattoo-supplies.myshopify.com',
  'elitejerseys-1394.myshopify.com',
  'elodie-details-uae.myshopify.com',
  'elkthelabel-us.myshopify.com',
  'enspiredby.myshopify.com',
  'espresso-planet-staging.myshopify.com',
  'epochlax.myshopify.com',
  'etonic1876.myshopify.com',
  'evengreener.myshopify.com',
  'eventsinabox.myshopify.com',
  'evanhealy.myshopify.com',
  'f0fef8.myshopify.com',
  'f145f0-4.myshopify.com',
  'f5a925-2.myshopify.com',
  'f8bc06.myshopify.com',
  'f5d096-2.myshopify.com',
  'fa03ce.myshopify.com',
  'facemeetcp.myshopify.com',
  'fancy-sunglasses-shop.myshopify.com',
  'fc3821.myshopify.com',
  'fenton-and-co.myshopify.com',
  'fipsas22.myshopify.com',
  'floridafreedivers.myshopify.com',
  'fne-the-brand.myshopify.com',
  'fox-racing-en-mexico.myshopify.com',
  'frau-kauf.myshopify.com',
  'foxchapel.myshopify.com',
  'fraktal-si.myshopify.com',
  'fractal-designs-london-ontario.myshopify.com',
  'freshskis.myshopify.com',
  'frockandfrill.myshopify.com',
  'fresh-n-marine-aquarium.myshopify.com',
  'funkychunky-promo.myshopify.com',
  'garden-fountains.myshopify.com',
  'garage89-1009-3.myshopify.com',
  'ganemjewelers.myshopify.com',
  'gem-center-usa-wholesale.myshopify.com',
  'get-rhino-protected.myshopify.com',
  'gioielleria-capodagli.myshopify.com',
  'gloskin-beauty.myshopify.com',
  'glowdecor.myshopify.com',
  'global-picollet.myshopify.com',
  'go-sleek-salon.myshopify.com',
  'goruck-demo.myshopify.com',
  'gospaorg.myshopify.com',
  'gracia-kids-1890.myshopify.com',
  'golf-cart-people.myshopify.com',
  'granvia-linea.myshopify.com',
  'great-trango-holdings-inc.myshopify.com',
  'gruponosaracr.myshopify.com',
  'hairlaya.myshopify.com',
  'hand-me-upp.myshopify.com',
  'hammerbacher.myshopify.com',
  'happyaslarrydesigns.myshopify.com',
  'happysoaps-se.myshopify.com',
  'heartypet.myshopify.com',
  'heest.myshopify.com',
  'hellbent-performance-products.myshopify.com',
  'heydudeshoes.myshopify.com',
  'hbloch.myshopify.com',
  'herzog-jewelers.myshopify.com',
  'hobbyhorseinc.myshopify.com',
  'his-way-herenmode.myshopify.com',
  'holders-diesel-performance.myshopify.com',
  'hololive.myshopify.com',
  'hugglehounds.myshopify.com',
  'houseandhomestyle1.myshopify.com',
  'house-of-glemore.myshopify.com',
  'hustlingshop.myshopify.com',
  'i-am-woman-sa.myshopify.com',
  'hydrogenperoxide.myshopify.com',
  'i-am-eva-period-proof-underwear.myshopify.com',
  'ikt-boutique.myshopify.com',
  'impactcoach.myshopify.com',
  'imi-jewelery-demo.myshopify.com',
  'ikkari-development.myshopify.com',
  'inkspire-japan.myshopify.com',
  'ipanemasouthafrica.myshopify.com',
  'invotech-mx-online.myshopify.com',
  'jackall-online-shop.myshopify.com',
  'irvine-art-and-music.myshopify.com',
  'jacques-specialists.myshopify.com',
  'jaes-jewelers.myshopify.com',
  'jackfruitfurniture.myshopify.com',
  'jacintatienda.myshopify.com',
  'jigsaw-puzzles-direct.myshopify.com',
  'jj-ag-parts.myshopify.com',
  'joey-the-label.myshopify.com',
  'jp-rituals.myshopify.com',
  'jtm-auto-4x4-parts-accessories.myshopify.com',
  'kairyushop.myshopify.com',
  'kamashoinc-2.myshopify.com',
  'kateliva.myshopify.com',
  'kandakirat.myshopify.com',
  'kb-ottawa-plants.myshopify.com',
  'kd-solar.myshopify.com',
  'keelaoutdoors.myshopify.com',
  'kala-marmoles.myshopify.com',
  'key-compostables.myshopify.com',
  'kerata.myshopify.com',
  'kickback-shoes.myshopify.com',
  'koraru-store.myshopify.com',
  'knowthedrills.myshopify.com',
  'konkurspriserse.myshopify.com',
  'labelsbythebay.myshopify.com',
  'la-uniformeria.myshopify.com',
  'lady-epis-shoppe.myshopify.com',
  'langerchen.myshopify.com',
  'lance-co-jewelers.myshopify.com',
  'lagattaconglistivali-store.myshopify.com',
  'langolodellemeraviglie.myshopify.com',
  'lay-it-flat.myshopify.com',
  'lecoqsportifsa.myshopify.com',
  'legit-grit.myshopify.com',
  'linefurnituredenmark.myshopify.com',
  'lichttechnik24-de.myshopify.com',
  'liquorstoretest.myshopify.com',
  'linefurnituregroup.myshopify.com',
  'livinlinens.myshopify.com',
  'lithos-diamonds.myshopify.com',
  'loomandloft.myshopify.com',
  'loop-plus-bow.myshopify.com',
  'lovebycomo.myshopify.com',
  'loon-outdoors.myshopify.com',
  'luchs-vn.myshopify.com',
  'ltlparts.myshopify.com',
  'lunalaeb2b.myshopify.com',
  'luum-textiles-dev.myshopify.com',
  'lumi-lighting.myshopify.com',
  'madoneco.myshopify.com',
  'maison-venu-7432.myshopify.com',
  'mamasuncut-store.myshopify.com',
  'manore-shop.myshopify.com',
  'markcross1845.myshopify.com',
  'love-in-faith.myshopify.com',
  'mattressmattresstore.myshopify.com',
  'mechioau.myshopify.com',
  'mega-brown-box.myshopify.com',
  'meg-lizabet.myshopify.com',
  'mays-jewellery.myshopify.com',
  'mff-stg-easyspirit.myshopify.com',
  'michelle-accesorios-4383.myshopify.com',
  'menmomswebstore.myshopify.com',
  'mikisapiy.myshopify.com',
  'minjion.myshopify.com',
  'milemarkerinc.myshopify.com',
  'misssunshinenailss.myshopify.com',
  'minter-and-richter-designs.myshopify.com',
  'mobuofficial.myshopify.com',
  'mixperfume.myshopify.com',
  'moms-the-word-2.myshopify.com',
  'monitaya.myshopify.com',
  'monkeycatde.myshopify.com',
  'morrison-dev.myshopify.com',
  'morrisonaustralia.myshopify.com',
  'more-loop.myshopify.com',
  'monisha-melwani-jewelry.myshopify.com',
  'mount-vernon-coin.myshopify.com',
  'mr-indeva.myshopify.com',
  'moral-code-store.myshopify.com',
  'mundo-outdoors-shop.myshopify.com',
  'murray2019.myshopify.com',
  'movewithbluee.myshopify.com',
  'mureta-co.myshopify.com',
  'mutual-muse.myshopify.com',
  'mysamsungstraps.myshopify.com',
  'myriadbeautystore.myshopify.com',
  'mynewcastle.myshopify.com',
  'mystudio206.myshopify.com',
  'nailster-norway.myshopify.com',
  'nailster-sweden.myshopify.com',
  'nally-jewels.myshopify.com',
  'nailster-denmark.myshopify.com',
  'na-development-store.myshopify.com',
  'naudic.myshopify.com',
  'native-linum.myshopify.com',
  'nbluxe-us.myshopify.com',
  'nerd-stuff-of-alabama.myshopify.com',
  'nerias.myshopify.com',
  'new-enerj.myshopify.com',
  'nice-car-collections.myshopify.com',
  'nigel-rayment-boutiques.myshopify.com',
  'nnn-uae-global.myshopify.com',
  'noelathome.myshopify.com',
  'nordbythomsen.myshopify.com',
  'nosix-co-uk.myshopify.com',
  'nutramedix-products.myshopify.com',
  'ob-vape.myshopify.com',
  'o13-x-thewoods.myshopify.com',
  'okeycasual.myshopify.com',
  'oh-thanks.myshopify.com',
  'olokuti.myshopify.com',
  'omakase-tokyo.myshopify.com',
  'organax-6434.myshopify.com',
  'otiumberg.myshopify.com',
  'orase.myshopify.com',
  'ourhomehaus.myshopify.com',
  'outdoorkid-pl.myshopify.com',
  'ovais-abaya-collection-store.myshopify.com',
  'outletstore24a.myshopify.com',
  'oway-b2c.myshopify.com',
  'pacificboardertest.myshopify.com',
  'paddockperformance.myshopify.com',
  'panayotis.myshopify.com',
  'paper-and-grace.myshopify.com',
  'papercrush-de.myshopify.com',
  'pappos-mx.myshopify.com',
  'pandp-3.myshopify.com',
  'parrotstation-com.myshopify.com',
  'parfum-exquis-us.myshopify.com',
  'parkside-skateshop.myshopify.com',
  'pepcell-sa.myshopify.com',
  'pell-1990.myshopify.com',
  'peintio.myshopify.com',
  'pet-natural-store.myshopify.com',
  'petit-seal.myshopify.com',
  'petit-collage.myshopify.com',
  'pfaa2u.myshopify.com',
  'pixusjacquelinesscrubs.myshopify.com',
  'pixusmerseyflooring.myshopify.com',
  'plain-jane-shop.myshopify.com',
  'pixusfashionsznnew.myshopify.com',
  'plastic-world-solutions.myshopify.com',
  'plants-for-humans.myshopify.com',
  'pmr-customs.myshopify.com',
  'plug-and-playy.myshopify.com',
  'poe-net.myshopify.com',
  'pod-shoes.myshopify.com',
  'porsche-japan.myshopify.com',
  'pre-packs.myshopify.com',
  'precorhomefitness.myshopify.com',
  'premium-diagnostics.myshopify.com',
  'prestigeclt.myshopify.com',
  'professional-jewelers.myshopify.com',
  'pro-australia.myshopify.com',
  'pws-dev-ca.myshopify.com',
  'pure-cotton-comfort.myshopify.com',
  'rainsisters.myshopify.com',
  'rashidcassimsports.myshopify.com',
  'raxautos.myshopify.com',
  'rcawd.myshopify.com',
  're-fabbed.myshopify.com',
  'rebrand-trading.myshopify.com',
  'reflo-athleisure.myshopify.com',
  'respiro-indonesia.myshopify.com',
  'retail-boyz-shop.myshopify.com',
  'resistol.myshopify.com',
  'rewinddesign.myshopify.com',
  'reuplane.myshopify.com',
  'rodeoh-b2b.myshopify.com',
  'roma-customers.myshopify.com',
  'roland-sands-design-4611.myshopify.com',
  'roseandthorne.myshopify.com',
  'rosery-flowers.myshopify.com',
  'rtfbikeparts.myshopify.com',
  'rubino-shoehub.myshopify.com',
  'rv6-wholesale.myshopify.com',
  'safety-giant.myshopify.com',
  'rotatechproducts.myshopify.com',
  'sabellah.myshopify.com',
  'sabasnet.myshopify.com',
  'saltaire-antiques.myshopify.com',
  'salwarstudio.myshopify.com',
  'scents-284.myshopify.com',
  'scorpifyus.myshopify.com',
  'scoutandrebel.myshopify.com',
  'secondhandkiste.myshopify.com',
  'satoyaku.myshopify.com',
  'seven-mx-canada.myshopify.com',
  'seeeyewear.myshopify.com',
  'sewsoutherndesigns1.myshopify.com',
  'sg-fashiontofigure.myshopify.com',
  'sg-nyandco.myshopify.com',
  'shop-sole-therapy.myshopify.com',
  'shop-chevalier.myshopify.com',
  'shop-online-timack.myshopify.com',
  'shopnyra.myshopify.com',
  'shopxclusivesneakers.myshopify.com',
  'shuggie-co.myshopify.com',
  'shoprecordstore.myshopify.com',
  'sikhestperformance.myshopify.com',
  'sillou.myshopify.com',
  'simplyfashion-no.myshopify.com',
  'site-garant.myshopify.com',
  'skatescool-shop.myshopify.com',
  'skullvikings.myshopify.com',
  'skora-australia.myshopify.com',
  'slam-next.myshopify.com',
  'sky-manor.myshopify.com',
  'sk-belleza.myshopify.com',
  'sm-ca-shop.myshopify.com',
  'sm-wisetekusa.myshopify.com',
  'socksrock.myshopify.com',
  'soin-de-toi.myshopify.com',
  'snow-moon-press-shop.myshopify.com',
  'sokkat.myshopify.com',
  'sophias-costume.myshopify.com',
  'solovintage-jp.myshopify.com',
  'soundpaint.myshopify.com',
  'solidstateprints.myshopify.com',
  'southern-drawl-store.myshopify.com',
  'splay-outlet.myshopify.com',
  'speedcubing-org.myshopify.com',
  'sport-vl-2-0.myshopify.com',
  'spray-foam-equipment.myshopify.com',
  'sportsleisureau.myshopify.com',
  'spreezer.myshopify.com',
  'stagingxplct.myshopify.com',
  'star-luxury-vintage.myshopify.com',
  'staging4hiyaku.myshopify.com',
  'stayhumanonearth.myshopify.com',
  'still-here-new-york.myshopify.com',
  'state-of-escape.myshopify.com',
  'steel-barnett.myshopify.com',
  'steep-mountain-tea.myshopify.com',
  'sticky-black-tarmac.myshopify.com',
  'stienhard-stones.myshopify.com',
  'strut-menwear.myshopify.com',
  'sugarboxusa.myshopify.com',
  'style-mouktika.myshopify.com',
  'sujimyshopify.myshopify.com',
  'sugistrading-dev.myshopify.com',
  'sugistrading-tw.myshopify.com',
  'sunsum-intention-candles.myshopify.com',
  'suzysfine-jewellery.myshopify.com',
  'swell-wellness.myshopify.com',
  'sziro-jewelry.myshopify.com',
  'takonyan.myshopify.com',
  'tangollector.myshopify.com',
  'take-five-trading.myshopify.com',
  'tbn-db-nz.myshopify.com',
  'teakunique.myshopify.com',
  'teq-customs-llc.myshopify.com',
  'testshopoasis.myshopify.com',
  'thai-vape-shop.myshopify.com',
  'the-boot-jack.myshopify.com',
  'the-decorators-1949.myshopify.com',
  'the-freeze-dried-candy-store-wholesale.myshopify.com',
  'the-irish-flute-store.myshopify.com',
  'the-mens-room-shop.myshopify.com',
  'the-perfect-workout-8102.myshopify.com',
  'the-rail-ph.myshopify.com',
  'the-thrifting-den.myshopify.com',
  'the-union-project-2-0.myshopify.com',
  'theecommkid.myshopify.com',
  'thegemflystore.myshopify.com',
  'theyorkshirejigsawstore.myshopify.com',
  'thesint.myshopify.com',
  'thepets-dk.myshopify.com',
  'thestonemart.myshopify.com',
  'tifosi-optics.myshopify.com',
  'tn-americas.myshopify.com',
  'togah.myshopify.com',
  'tienda-multimax.myshopify.com',
  'tmkbeauty.myshopify.com',
  'toad-co-golden.myshopify.com',
  'toledo-dealer-services.myshopify.com',
  'tolly-toys.myshopify.com',
  'tonerprofis24.myshopify.com',
  'topologiejp.myshopify.com',
  'topologiestaging.myshopify.com',
  'tr-beegoddess.myshopify.com',
  'tracmaster.myshopify.com',
  'trendsbeautyaustraliaaa.myshopify.com',
  'trusports-in.myshopify.com',
  'turquoiselane.myshopify.com',
  'twelveboardstore.myshopify.com',
  'twgtea.myshopify.com',
  'txcom-ads.myshopify.com',
  'twisted-thread.myshopify.com',
  'uk-water-filters.myshopify.com',
  'um-x-flanci.myshopify.com',
  'upmarket-scents.myshopify.com',
  'unicorn-egg.myshopify.com',
  'used-legends-direct.myshopify.com',
  'vactam.myshopify.com',
  'uyeki-online-shop.myshopify.com',
  'vanezia.myshopify.com',
  'velaireat.myshopify.com',
  'us-alterraretail.myshopify.com',
  'verb-by-pallavi-singhee.myshopify.com',
  'vividads-com-au.myshopify.com',
  'vinod-patel-fiji.myshopify.com',
  'vitaman-usa.myshopify.com',
  'voda-flooring.myshopify.com',
  'voda-boutique.myshopify.com',
  'volcano-gaming-8840.myshopify.com',
  'voilondon-me.myshopify.com',
  'vulcan-grips.myshopify.com',
  'vulkan.myshopify.com',
  'wallpaper-trader.myshopify.com',
  'walker-wade.myshopify.com',
  'wagtail-is.myshopify.com',
  'vrjewels-us.myshopify.com',
  'we-got-that-juice.myshopify.com',
  'watts-oguchi.myshopify.com',
  'watts-jp.myshopify.com',
  'wearhouse-com-au.myshopify.com',
  'waxing-kara.myshopify.com',
  'wedding-shoppe-inc.myshopify.com',
  'water-filters-fast.myshopify.com',
  'way-funky-deutschland.myshopify.com',
  'webblouse.myshopify.com',
  'website-test-1.myshopify.com',
  'west-coast-garage-2024.myshopify.com',
  'white-horse-vapor.myshopify.com',
  'wind-throttle.myshopify.com',
  'wild-poppies-nz.myshopify.com',
  'winesonlinenz.myshopify.com',
  'wishtrend-com.myshopify.com',
  'wine-vitage.myshopify.com',
  'wit-fitness.myshopify.com',
  'wohlfuehlprodukte.myshopify.com',
  'wonderland-us-shower-inc.myshopify.com',
  'wonderland-shower-inc.myshopify.com',
  'worthington-millwork.myshopify.com',
  'worldofluxuryus-1260.myshopify.com',
  'worldwide-floors.myshopify.com',
  'www-salonweardirect-co-uk.myshopify.com',
  'www-kidshoesdirect-com.myshopify.com',
  'xishina.myshopify.com',
  'www-entertainmentstore-in.myshopify.com',
  'www-vetniquelabs-com.myshopify.com',
  'www-rubaiyatfashion-com.myshopify.com',
  'xn-heubc2a1ener3d6eb2iqc6erfg0h4b1jmhe.myshopify.com',
  'xn-n8jvb278m3eo8wkgij61s.myshopify.com',
  'yogamii.myshopify.com',
  'xn-rss49j3pis1mu86b.myshopify.com',
  'ysa-jewelry-3628.myshopify.com',
  'zaff-light.myshopify.com',
  'zamst-canada.myshopify.com',
  'zenoni-colombi.myshopify.com',
  'zsiskadesign.myshopify.com',
  'zepbrook.myshopify.com',
  'zvoovfashion.myshopify.com'
];

export function isInWhiteListTurbo(tenantId: string) {
  const whitelist =
    process.env.REACT_APP_ENV === 'staging' ? WHITELIST_TURBO_STAGING : WHITELIST_TURBO_PRODUCTION;
  return whitelist.includes(tenantId);
}

// https://clearerio.atlassian.net/browse/BC-6209
export function isInWhiteListTurboBanner(tenantId: string) {
  const whitelist =
    process.env.REACT_APP_ENV === 'staging'
      ? WHITELIST_TURBO_BANNER_STAGING
      : WHITELIST_TURBO_CAMPAIGN_PRODUCTION;
  return whitelist.includes(tenantId) && isInTimeRangeCampaign();
}

export function isInTimeRangeCampaign() {
  const today = moment();
  const isBetweenTimeRangeTurboCampaign =
    process.env.REACT_APP_ENV === 'staging'
      ? true
      : today.isSameOrAfter(turboCampaignStart, 'day') &&
        today.isSameOrBefore(turboCampaignEnd, 'day');
  return isBetweenTimeRangeTurboCampaign;
}

export const turboCampaignStart = moment('15/04/2025', 'DD/MM/YYYY'); // Time campaign production
export const turboCampaignEnd = moment('05/05/2025', 'DD/MM/YYYY'); // Time campaign production
